import '@patsnap-ui/icon/assets/solid/TickCircle.svg'
import { sharedCtx } from '@pharmsnap/shared/context'
import { useLocale } from '@pharmsnap/shared/src/composition'
import { TRANSLATIONAL_MEDICINE_LIST_QUERY_KEY } from '@pharmsnap/shared/src/types/translational-medicine'
import { getTargetName } from '@pharmsnap/shared/src/utils/target'
import { IBaseTargetInfo } from '@pharmsnap/shared/types'
import { computed, defineComponent, PropType, toRefs } from '@vue/composition-api'
import { BEntityTag, BTargetPopperCard, GIcon, GLink, GTooltip } from '../..'
import $style from './BTargetItem.module.scss'

export const BTargetItem = defineComponent({
  name: 'BTargetItem',
  props: {
    data: {
      required: true,
      type: Object as PropType<IBaseTargetInfo>,
    },
    popover: {
      type: Boolean,
      default: true,
    },
    showIcon: {
      type: Boolean,
      default: false,
    },
    /**
     * 取名逻辑是否需要降级
     * 邮件提醒变更详情，需要降级，不然后端需要刷历史变更数据
     */
    isNameNeedDegrade: {
      type: Boolean,
      default: false,
    },
    coreIds: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    tmIds: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
  },
  setup(props, ctx) {
    const { locale } = useLocale()

    const { data } = toRefs(props)
    const href = computed(() => sharedCtx.router.generatorTargetPath(data?.value?.target_id || ''))
    const showCoreIcon = computed(() => props.coreIds.includes(data?.value?.target_id || ''))
    const isTranslationalMedicine = computed(() => ctx.root.$route?.query?.from === TRANSLATIONAL_MEDICINE_LIST_QUERY_KEY)
    const showTmIcon = computed(() => isTranslationalMedicine.value && props.tmIds.includes(data?.value?.target_id || ''))
    const name = computed(() => {
      if (data.value) {
        return getTargetName(data.value, locale.value) as string
      }
      return ''
    })
    const contentCls = showTmIcon.value ? $style.highlightTm : ''
    return {
      href,
      name,
      showCoreIcon,
      showTmIcon,
      contentCls,
    }
  },
  render() {
    const id = this.data.target_id
    const fontClassName = this.data.fontClassName || ('' as string)
    const name = this.name as string
    const href = this.href as string
    const content = this.showTmIcon ? (
      <span class={[this.contentCls, 'max-w-full inline-block']}>
        <BEntityTag class={this.contentCls} data-testid="b-target-item">
          {this.showIcon ? <GIcon class="text-text-t2 mr-1 flex-shrink-0" svgName="Target" /> : null}
          <GLink data-selection-disabled={this.popover} href={href} name={name} encryptClass={fontClassName}></GLink>
          {this.showCoreIcon && (
            <GTooltip
              class="mr-[-2px]"
              theme="light"
              mode="icon"
              iconSize={20}
              iconName="SolidTickCircle"
              iconClass="text-blue-default"
              content={this.$tc('common.coreEntity')}
            ></GTooltip>
          )}
        </BEntityTag>
      </span>
    ) : (
      <BEntityTag data-testid="b-target-item" title={this.name}>
        {this.showIcon ? <GIcon class="text-text-t2 mr-1 flex-shrink-0" svgName="Target" /> : null}
        <GLink data-selection-disabled={this.popover} href={href} name={name} encryptClass={fontClassName}></GLink>
      </BEntityTag>
    )
    if (id && this.popover) {
      return <BTargetPopperCard id={id}>{content}</BTargetPopperCard>
    }
    return content
  },
})
